import { Container, Fade } from "@mui/material";
import { SlideInContextProvider } from "../../context/SlideInContext";
import SlideIn from "../components/SlideIn";
import AppBar from "../components/AppBar";
import { Navigate, Route, Routes, useNavigate } from "react-router";
import { DashboardPage } from "./DashboardPage";
import ResultsTable from "./components/ResultsTable";
import HistoryTable from "./components/HistoryTable";
import { WorkListContextProvider } from "../../context/WorkListsContext";
import KeywordTable from "./components/KeywordTable/KeywordTable";
const IndexPageRoutes = () => {

    const navigate = useNavigate();

    return (
        <Routes>
            <Route index element={<DashboardPage />} />
            <Route path="/student/:studentId/sessions" element={(
                <ResultsTable
                    activeStudent={null}
                    onSelectedSession={(studentId: string, sessionId: string) => {
                        navigate(`/dashboard/student/${studentId}/session/${sessionId}/notes`)
                    }}
                    onBack={() => {
                        navigate(-1);
                    }} />
            )} />
            <Route path="/student/:studentId/session/:sessionId/keyword" element={(<KeywordTable
                onBack={() => { navigate(-1) }}
            />)} />
            <Route path="student/:studentId/session/:sessionId/notes" element={(
                <HistoryTable
                    onBack={() => {
                        navigate(-1);
                    }} />
            )} />
            <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
    );
}


export default function IndexPage() {
    return (
        <WorkListContextProvider>
            <SlideInContextProvider>
                <AppBar />
                <SlideIn />
                <Fade appear in timeout={500}>
                    <Container maxWidth="xl">
                        <IndexPageRoutes />
                    </Container>
                </Fade>
            </SlideInContextProvider>
        </WorkListContextProvider>
    )
}